import UserApi from '@/services/rest/bemob/user';
import ApiServices from '@/services';
import api from '@/services/utils/base';
import store from '@/store';
import { forceCleanCache } from '@/services/utils/websocket';

export class UserManagerApi {
  loading: boolean = false;
  error: boolean = false;

  data: any = [];
  dataNormalized: any = {};
  dataItemsRelations: object = {};
  user_acl: object = {};

  userApi: UserApi = new UserApi();

  getMembers() {
    this.loading = true;
    // @ts-ignore
    return this.userApi.getAllMembers().then((payload: any) => {
      const dataNormalized:any = {}
      payload.forEach((member:any)=>{
        member.fullName = (member.firstName || '') + (member.lastName ? ' ' + member.lastName : '')
        dataNormalized[member.id]=member
      });

      this.dataNormalized = dataNormalized;
      this.data = payload;

      this.loading = false;
      return Promise.resolve(payload);
    });
  }

  getMember(id: string) {
    this.loading = true;
    // @ts-ignore
    return this.userApi.getMember(id).then((payload: any) => {
      // this.data = payload;
      this.loading = false;
      return payload;
    });
  }

  put(id: string, payload: object) {
    return this.userApi.putMember(id, payload).then(async (res: any) => {
      await ApiServices.getUserProfile();
      return Promise.resolve(res);
    });
  }

  post(data: object) {
    this.loading = true;
    // @ts-ignore
    return this.userApi.postCreateMember(data).then(async (payload: any) => {
      await ApiServices.getUserProfile();
      this.loading = false;
      return payload;
    });
  }

  delete(id: string) {
    return this.userApi.deleteMember(id).then(async (payload: any) => {
      await ApiServices.getUserProfile();
      return Promise.resolve(payload);
    });
  }



  getItemsRelations(params:any) {
    this.loading = true;
    // @ts-ignore
    return this.userApi.getItemsRelations(params).then((payload: any) => {
      this.dataItemsRelations = payload;
      this.loading = false;
      return payload;
    });
  }

  getMemberPermissions({userId,workspaceIds}:{userId: string,workspaceIds?: any}) {
    return api.get(`user/members/${userId}/permissions`, {params: {workspaceIds}})
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  putMemberAcl({userId}:{userId: string}, payload: object) {
    this.loading = true;
    return api.put(`user/members/${userId}/permissions`, payload)
    .then((payload: any) => {
      this.loading = false;
      return payload;
    });
  }

  postResetPassword(id: string) {
    this.loading = true;
    return this.userApi.postResetPassword(id).then((payload: any) => {
      this.loading = false;
      return payload;
    });
  }

  patchCloseBanner() {
    store.commit('loading', true);
    return api.patch('user', {'workspacesHelpClosed': true})
    .then(async (res: any) => {
      store.commit('updateUser', res.data.payload);
      store.commit('loading', false);
    });
  }

}

export const impersonateMember = ({id,email}: { id:string,email:string })=>{
  window.sessionStorage.setItem('impersonation',JSON.stringify({
    id,
    email
  }));
  
  forceCleanCache();
  window.location.reload();
}

export default new UserManagerApi();
